import React from 'react';
import { Link } from 'react-router-dom';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const swiperOptions = {
  modules: [Autoplay, Pagination, Navigation],
  slidesPerView: 2,
  spaceBetween: 30,
  speed: 2000,
  autoplay: {
    delay: 9000,
    disableOnInteraction: false,
  },
  loop: true,
  navigation: {
    nextEl: '.swiper-button-prev1',
    prevEl: '.swiper-button-next1',
  },
  pagination: {
    el: '.swiper-dot-style1',
    type: 'bullets',
    clickable: true,
  },
  breakpoints: {
    0: {
      spaceBetween: 0,
      slidesPerView: 1,
    },
    375: {
      spaceBetween: 0,
      slidesPerView: 1,
    },
    575: {
      spaceBetween: 0,
      slidesPerView: 1,
    },
    768: {
      spaceBetween: 30,
      slidesPerView: 1,
    },
    992: {
      spaceBetween: 30,
      slidesPerView: 2,
    },
    1200: {
      spaceBetween: 30,
      slidesPerView: 3,
    },
    1320: {
      spaceBetween: 30,
      slidesPerView: 3,
    },
  },
};

export default function ServiceSlider() {
  return (
    <Swiper {...swiperOptions} className="thm-swiper__slider swiper-container">
      <div className="swiper-wrapper">
        <SwiperSlide className="swiper-slide">
          <div className="services-carousel__single">
            <div className="services-one__icon">
              <span className="icon-postbox" />
            </div>
            <h3 className="services-one__title">
              {/* <Link to="/express-freight-solutions"> */}
              ARCH trains pros. <br/>Quality isn’t a goal — it’s our standard.
              {/* </Link> */}
            </h3>
            <div className="services-one__btn-box">
              {/* <Link to="/express-freight-solutions" className="thm-btn services-one__btn">
                Read more
                <span />
              </Link> */}
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide className="swiper-slide">
          <div className="services-carousel__single">
            <div className="services-one__icon">
              <span className="icon-customer-service" />
            </div>
            <h3 className="services-one__title">
              {/* <Link to="/quick-move-logistics"> */}
              ARCH connects the dots for flawless service and unmatched quality.
              {/* </Link> */}
            </h3>

          </div>
        </SwiperSlide>
        <SwiperSlide className="swiper-slide">
          <div className="services-carousel__single">
            <div className="services-one__icon">
              <span className="icon-container" />
            </div>
            <h3 className="services-one__title">
              
            Engineered for Uptime. Powered 24/7 by Smart Tech — Rain or Shine.
              
            </h3>
 
          </div>
        </SwiperSlide>
        <SwiperSlide className="swiper-slide">
          <div className="services-carousel__single">
            <div className="services-one__icon">
              <span className="icon-shipping" />
            </div>
            <h3 className="services-one__title">
              
            ARCH Crafts High-Tech Repair Commitments, Focused on Uptime and Perfection.
              
            </h3>
            
          </div>
        </SwiperSlide>
        <SwiperSlide className="swiper-slide">
          <div className="services-carousel__single">
            <div className="services-one__icon">
              <span className="icon-crane" />
            </div>
            <h3 className="services-one__title">
              
              For Major Projects, ARCH Deploys Elite Teams for Predictive Testing and Smart Maintenance.
              
            </h3>
            <div className="services-one__btn-box">
              
            </div>
          </div>
        </SwiperSlide>
       
      </div>
    </Swiper>
  );
}
